import axios from "axios";
import Cookies from "js-cookie";
import React, { useCallback, useState } from "react";

import { fetchStream } from "../Api/request";

/**
 *
 * @param {Object} params
 * @param {string} params.url - The URL to connect to the AI stream.
 * @returns
 */
export const useAIStream = (params) => {
	const { url } = params;

	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const [data, setData] = useState("");

	const makeRequest = useCallback(
		async (data) => {
			setIsLoading(true);
			setError(null);
			setData("");

			let response = null;

			try {
				response = await fetchStream({
					url: url,
					data: data,
				});

				const reader = response.body.getReader();
				const decoder = new TextDecoder();

				const loopRunner = true;

				while (loopRunner) {
					// Here we start reading the stream, until its done.
					const { value, done } = await reader.read();
					if (done) {
						break;
					}
					const decodedChunk = decoder.decode(value, { stream: true });
					setData((answer) => answer + decodedChunk); // update state with new chunk
				}
			} catch (error) {
				setError(error);
			} finally {
				setIsLoading(false);
			}

			return response?.data ?? null;
		},
		[url]
	);

	return { data, isLoading, error, makeRequest };
};
